import {
    Log, LogLevel,
} from 'one-log';

import {
    init,
} from 'ccw-app';

import {
    loader,
} from 'one-web-loader';
import { enableTrace } from "one-trace";

import {
    AlertNotification
} from "one-alert-notification";

import {
    BrowserLogger,
} from 'one-web-logger';
import { HAServer, HAServerOne } from 'one-server-local-ha';

// set up the logger
const log = new Log("ccw-app",[
    new BrowserLogger(),
],LogLevel.DEBUG);

loader({
    log,
    url: 'settings.json',
}, (options: any) => (
    new Promise(async (resolve) => {
        const {
            settings,
            resolver,
        } = options;

        /**
         * check for the log level config from settings and set default
         */
        const {logconfig,alertnotify} = settings;
        if(logconfig?.level==="INFO"){
            log.setlevel(LogLevel.INFO);
        } else  if(logconfig?.level==="WARN"){
            log.setlevel(LogLevel.WARN);
        } else  if(logconfig?.level==="ERROR"){
            log.setlevel(LogLevel.ERROR);
        } else{
            log.setlevel(LogLevel.DEBUG);
        }
        log.debug(
            'ccw-app-web',
            'app settings', {
            settings,
        });

          // logged in agent id
          const agentId = '761012';
          // adding ani
          const ani = '';
          let alertnotification = new AlertNotification(false,alertnotify?.url,{
                             });
          if(alertnotify?.enable){
            alertnotification = new AlertNotification(true,alertnotify?.url,{
              customer_name:alertnotify?.customer,
              server_id:alertnotify?.servername,
              app_type:"web"
          })
          }
            // enable user specific trace
            enableTrace(agentId, {
                log,
                settings,
            });

        // initialize the app
        const {
            store,
        } = await init('app', {
            log,
            agentId,
            ani,
            settings,
            resolver,
            alertnotification,
            server: new HAServer(
                settings['servers'],
                (url:string,error: any) => {
                    store.dispatch({
                        type: "one-state-errorhandle/set",
                        payload: {
                            url: url,
                            error: error,
                            monitor: false
                        }
                    })
                }
            ),
            serverone: new HAServerOne(
                settings['servers'],
                (url:string,error: any) => {
                    store.dispatch({
                        type: "one-state-errorhandle/set",
                        payload: {
                            url: url,
                            error: error,
                            monitor: false
                        }
                    })
                }
            ),
        });

        resolve({
            log,
            // next is optional
            next: (params: any) => {
                console.debug(
                    'ccw-app-twilio',
                    'finished initialization...', {
                    params,
                });
                return Promise.resolve({
                    store,
                });
            },
        });
    })
));